import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

import { HoverCard, IBasePicker, IBasePickerSuggestionsProps, IExpandingCardProps, IPersonaProps, IPickerItemProps, Label, mergeStyleSets, NormalPeoplePicker, PeoplePickerItem, Persona, PersonaSize, ValidationState, Shimmer, ShimmerElementsGroup, ShimmerElementType, DirectionalHint, ITag, IBasePickerProps, IInputProps } from '@fluentui/react';

import { IField, ILookupField , IContact } from '../../../shared/interfaces';
import { Indici_FormMode, Search_QueryOperator } from '../../../shared/enums';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import contactsService from '../../../services/contacts.service';
import { useBoolean } from '@fluentui/react-hooks';
import axios, { CancelTokenSource } from 'axios';
import { toastRef } from '../../Layout/Layout';
import ContactInfo from '../../../sharedComponents/ContactInfo';
import ArxeiaLabel from '../ArxeiaLabel';


const classNames = mergeStyleSets({
    inputWrapper:
    {
        paddingBottom: '20px',

    },
    compactCard: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        padding: "0 20px"
    },
    expandedCard: {
        padding: '16px 24px 24px'
    },
    iconClass: {
        fontSize: 20,
        margin: '0 25px'
    },
    callout: {
        padding: '8px',
    },
    contactInfoGroup: {
        padding: '4px 0px',
    },

    address: {
        height: '20px'
    }
});


let cancelTokenSources = {};



export interface AutocompleteContactHandle {
}

export interface AutocompleteContactProps {
    formMode?: Indici_FormMode
    field: IField
    autofocus?: boolean,
    changed: (newField: IField) => void
    //onPaste: (ev: React.ClipboardEvent<HTMLInputElement>, newField: IField) => void
}
type Props = AutocompleteContactProps


const AutocompleteContact: React.ForwardRefRenderFunction<AutocompleteContactHandle, AutocompleteContactProps> = (props, ref) => {

    const peoplePickerRef = React.createRef<IBasePicker<IPersonaProps>>();


    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const [contactCard, setContactCard] = useState<any>();
    const [mostRecentlyContactsUsed, setMostRecentlyContactsUsed] = useState<any[]>([]);
    const [shimmerElementsVisible, { setTrue: showShimmerElements, setFalse: hideShimmerElements }] = useBoolean(false);

    useEffect(() => {
        // Anything in here is fired on component mount.


        return () => {
            // Anything in here is fired on component unmount.

            // cancello tutte le request in pending
            for (const [key, value] of Object.entries<CancelTokenSource>(cancelTokenSources)) {
                value.cancel(`${key} canceled`)
            }

        }
    }, [])




    let contactsField = props.field as ILookupField ;
    let contactsFieldBasePickerProps = contactsField.basePickerProps ? contactsField.basePickerProps as IBasePickerProps<IPersonaProps> : undefined;

    const contactsPickerSuggestionProps: IBasePickerSuggestionsProps = contactsFieldBasePickerProps?.pickerSuggestionsProps ??
    {
        suggestionsHeaderText: 'Suggerimenti',
        mostRecentlyUsedHeaderText: 'Contatti suggeriti',
        noResultsFoundText: 'Nessun risultato trovato',
        loadingText: 'Caricamento',
        showRemoveButtons: false,
        forceResolveText: "Cerca valore inserito",
        showForceResolve: props.formMode === Indici_FormMode.Search ? () => { return true } : () => { return false }
    };


    const inputChanged = (newField: IField) => {
        props.changed({ ...newField, valid: AppUtilities.checkFieldValidity(newField), touched: true })
    }

    //const inputPaste = (ev: React.ClipboardEvent<HTMLInputElement>) => {
    //    props.onPaste(ev, { ...contactsField })
    //}

    //const inputProps: IInputProps = { onPaste: inputPaste };


    let selectedContacts: any[] = [];
    if (contactsField.internalValue)
        selectedContacts = [...contactsField.internalValue];


    const createGenericItem = (input: string) => {
        let tag = { key: input, text: input, isGenericItem: true }
        return tag;
    }


    const onResolveSuggestions = contactsFieldBasePickerProps?.onResolveSuggestions === undefined
        ? async (filterText: string, currentContacts?: IPersonaProps[]): Promise<IPersonaProps[]> => {
            if (currentAoo && filterText) {
                let filteredContacts = await filterContactsByText(currentAoo.id, filterText);

                if (currentContacts)
                    filteredContacts = removeContactsPickerDuplicates(filteredContacts, currentContacts);

                return filteredContacts;
            } else {
                return [];
            }
        }
        : contactsFieldBasePickerProps.onResolveSuggestions;

    const filterContactsByText = async (aooId: number, filterText: string): Promise<IPersonaProps[]> => {
        let contacts: any[] = [];
        await contactsService.getContactSuggestions(aooId, filterText.toLowerCase())
            .then(suggestions => {
                suggestions.forEach(contact => {
                    let secondaryText = contact.email1 ?? contact.email2 ?? "";
                    contacts.push(
                        {
                            key: contact.id,
                            imageInitials: contact.iniziali,
                            text: contact.contatto,
                            secondaryText: secondaryText,
                            showSecondaryText: true,
                            hidePersonaDetails: false,
                            contact
                        }
                    );
                })
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                } else if (!error.isErrorShown) {
                    toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile leggere le informazioni della rubrica`, life: 5000 });

                }

            });

;
        return contacts;
    };
    const removeContactsPickerDuplicates = (contacts: IPersonaProps[], possibleDupes: IPersonaProps[]) => {
        return contacts.filter(contact => possibleDupes.findIndex(el => el.key === contact.key) < 0);
    }


    const returnMostRecentlyContactsUsed = (currentContacts?: IPersonaProps[]) => {
        if (currentContacts)
            return removeContactsPickerDuplicates(mostRecentlyContactsUsed, currentContacts);
        else
            return mostRecentlyContactsUsed
    };


    const onContactSelected = (selectedItem: any): IPersonaProps | null => {
        let recent = [...mostRecentlyContactsUsed];
        recent.push({ selectedItem });
        //assegno l'operatore contains solo alle ricerche fatte aggiungendo un item custom 
        // e l'operatore equals alle ricerche fatte attraverso i suggerimenti
        let { search_QueryOperator } = contactsField;

        if (selectedItem.isGenericItem) {
            search_QueryOperator = Search_QueryOperator.Contains;
        } else {
            search_QueryOperator = Search_QueryOperator.Equals;
        }
        props.field.search_QueryOperator = search_QueryOperator;
        // restituendo null il component non aggiunge nessun elemento alla selezione e riesco a controllare
        // gli elementi selezionati tramite inputChanged(selectedItem) che setta l'internalValue del campo
        return selectedItem;
    }


    const onContactChange = (items?: any[]): void => {
        inputChanged({ ...contactsField, internalValue: items });
    };


    const onRenderSuggestionsItem = (persProps: any, itemProps): JSX.Element => {

        const expandingCardProps: IExpandingCardProps = {
            onRenderCompactCard: onRenderCompactCard,
            onRenderExpandedCard: onRenderExpandedCard,
            compactCardHeight: 120,
            directionalHint: DirectionalHint.rightTopEdge,
            directionalHintFixed: false,
            gapSpace: 16,
            calloutProps: {
                isBeakVisible: false,
                calloutWidth: 450

            },

            renderData: persProps,

        };

        if ((persProps.destinatarioProtocollo && persProps.destinatarioProtocollo.contactId)
            || (persProps.contact && persProps.contact.id)) {
            return (
                <div key={`Suggestion${persProps.key}`} style={{ padding: 5 }}>
                    <HoverCard expandingCardProps={expandingCardProps} >
                        <Persona
                            {...persProps}
                            size={PersonaSize.size32}
                            hidePersonaDetails={false}
                        />
                    </HoverCard>
                </div >);

        }
        else {
            return (
                <div key={`Suggestion${persProps.key}`} style={{ padding: 5 }}>
                    <Persona
                        {...persProps}
                        size={PersonaSize.size32}
                        hidePersonaDetails={false}
                    />
                </div >
            );


        }

    };



    const onRenderItem = (props: any) => {

        const persProps = {
            ...props,
            item: {
                ...props.item,
                ValidationState: ValidationState.valid,
                showSecondaryText: false,
            },
        };

        const expandingCardProps: IExpandingCardProps = {
            onRenderCompactCard: onRenderCompactCard,
            onRenderExpandedCard: onRenderExpandedCard,
            compactCardHeight: 120,
            directionalHint: DirectionalHint.rightTopEdge,
            directionalHintFixed: false,
            gapSpace: 16,
            calloutProps: {
                isBeakVisible: false,
                calloutWidth: 450

            },

            renderData: props.item,

        };
        if ((persProps.item.destinatarioProtocollo && persProps.item.destinatarioProtocollo.contactId) // caso della spedizione
            || (persProps.item.contact && persProps.item.contact.id) // caso del cotatto selezionato dalle suggestions
            || (persProps.item.contactId)) {// caso del contatto salvato negli indici (non ho il contatto completo ma solo l'id) 
            return (
                <div key={`Item${persProps.key}`} style={{ padding: 5 }}>
                    <HoverCard expandingCardProps={expandingCardProps} onCardHide={onCardHide} >
                        <PeoplePickerItem {...persProps} />
                    </HoverCard>
                </div >
            );

        }
        else {
            return (
                <div key={`Item${persProps.key}`} style={{ padding: 5 }}>
                    <PeoplePickerItem {...persProps} />
                </div >
            );


        }

    };
    const onCardHide = (): void => {
        setContactCard(undefined);
    };

    const onRenderCompactCard = (persProps): JSX.Element => {
        return (
            <div key={`CompactCard${persProps.key}`} className={classNames.compactCard}>
                <Persona
                    {...persProps}
                    size={PersonaSize.size56}
                    hidePersonaDetails={false}
                />
            </div>
        );
    };
    const onRenderExpandedCard = (persProps): JSX.Element => {
        getContactInfo(persProps);

        return (
            <div key={`ExpandedCard${persProps.key}`}>
                <Shimmer customElementsGroup={getShimmerElements()} isDataLoaded={!shimmerElementsVisible || contactCard}>
                    <div className={classNames.expandedCard}>
                        {contactCard &&
                            <ContactInfo contactCard={contactCard}></ContactInfo>
                        }
                    </div>
                </Shimmer>
            </div>

        );
    }

    const getContactInfo = (persProps) => {

        if (persProps.contact) { // caso del cotatto selezionato dalle suggestions
            setContactCard(persProps.contact);
            hideShimmerElements();
        }
        else if (persProps.destinatarioProtocollo && persProps.destinatarioProtocollo.contactId) {  // caso della spedizione
            if (!contactCard || (contactCard && contactCard.id !== persProps.destinatarioProtocollo.contactId)) {
                setContactCard(undefined);

                let cancelTokenKey = contactsService.getContactInfo.name + persProps.destinatarioProtocollo.contactId;
                if (!cancelTokenSources[cancelTokenKey]) {

                    for (const [key, value] of Object.entries<CancelTokenSource>(cancelTokenSources)) {
                        if (key.startsWith(contactsService.getContactInfo.name))
                            value.cancel(`Request ${key} annullata`)
                    }

                    cancelTokenSources[cancelTokenKey] = axios.CancelToken.source();


                    showShimmerElements();
                    contactsService.getContactInfo(currentAoo!.id, contactsField.list, persProps.destinatarioProtocollo.contactId, cancelTokenSources[cancelTokenKey].token)
                        .then(_contact => {
                            setContactCard(_contact);
                            hideShimmerElements();
                            delete cancelTokenSources[cancelTokenKey];


                        })
                        .catch(error => {
                            let errorContact:Partial<IContact> = {
                                id: persProps.key,
                                error: `Impossibile leggere le informazioni del contatto`
                            }
                            setContactCard(errorContact);
                            hideShimmerElements();
                            delete cancelTokenSources[cancelTokenKey];

                            if (axios.isCancel(error)) {
                                //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                                console.log(error.message);
                            }
                        //    else if (!error.isErrorShown) {
                        //        toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile leggere le informazioni del contatto`, life: 5000 });

                        //    }

                        });
                }
            }
        }
        else if (persProps.contactId) { // caso del contatto salvato negli indici (non ho il contatto completo ma solo l'id) 
            if (!contactCard || (contactCard && contactCard.id.toString() !== persProps.contactId)) {
                setContactCard(undefined);

                let cancelTokenKey = contactsService.getContactInfo.name + persProps.contactId;
                if (!cancelTokenSources[cancelTokenKey]) {

                    for (const [key, value] of Object.entries<CancelTokenSource>(cancelTokenSources)) {
                        if (key.startsWith(contactsService.getContactInfo.name))
                            value.cancel(`Request ${key} annullata`)
                    }

                    cancelTokenSources[cancelTokenKey] = axios.CancelToken.source();

                    showShimmerElements();
                    contactsService.getContactInfo(currentAoo!.id, contactsField.list, persProps.contactId, cancelTokenSources[cancelTokenKey].token)
                        .then(_contact => {
                            setContactCard(_contact);
                            hideShimmerElements();
                            delete cancelTokenSources[cancelTokenKey];


                        })
                        .catch(error => {
                            let errorContact: Partial<IContact> = {
                                id: persProps.key,
                                error: `Impossibile leggere le informazioni del contatto`
                            }
                            setContactCard(errorContact);
                            hideShimmerElements();
                            delete cancelTokenSources[cancelTokenKey];

                            if (axios.isCancel(error)) {
                                //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                                console.log(error.message);
                            }
                            //    else if (!error.isErrorShown) {
                            //        toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile leggere le informazioni del contatto`, life: 5000 });

                            //    }

                        });

                }
            }
        }
    }
    const getShimmerElements = (): JSX.Element => {
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>

                <ShimmerElementsGroup
                    flexWrap
                    width={'100%'}
                    shimmerElements={[


                        { type: ShimmerElementType.gap, width: '10%', height: 10 },
                        { type: ShimmerElementType.line, width: '35%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '55%', height: 10 },



                        { type: ShimmerElementType.gap, width: '10%', height: 20 },
                        { type: ShimmerElementType.line, width: '55%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: 20 },

                        { type: ShimmerElementType.gap, width: '10%', height: 20 },
                        { type: ShimmerElementType.line, width: '80%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: 20 },


                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },


                        { type: ShimmerElementType.gap, width: '10%', height: 20 },
                        { type: ShimmerElementType.line, width: '55%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: 20 },

                        { type: ShimmerElementType.gap, width: '10%', height: 20 },
                        { type: ShimmerElementType.line, width: '80%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: 20 },


                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },


                        { type: ShimmerElementType.gap, width: '10%', height: 20 },
                        { type: ShimmerElementType.line, width: '55%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: 20 },

                        { type: ShimmerElementType.gap, width: '10%', height: 20 },
                        { type: ShimmerElementType.line, width: '80%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: 20 },

                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },

                    ]}
                />

            </div>


        );
    };
    return (
        <div className={classNames.inputWrapper}>
            <div className={contactsField.touched && !contactsField.valid ? 'field error' : 'field'}>
                <ArxeiaLabel field={contactsField} />

                <NormalPeoplePicker
                    key={contactsField.internalName}
                    className={'ms-PeoplePicker'}
                    pickerSuggestionsProps={contactsPickerSuggestionProps}
                    getTextFromItem={getTextFromPersonaItem}
                    createGenericItem={contactsFieldBasePickerProps?.createGenericItem ?? createGenericItem}
                    selectionAriaLabel={'Selected contacts'}
                    removeButtonAriaLabel={'Remove'}
                    inputProps={contactsFieldBasePickerProps?.inputProps}
                    resolveDelay={300}
                    disabled={contactsField.readonly || contactsField.disabled}
                    selectedItems={selectedContacts}
                    itemLimit={contactsField.multi && props.formMode !== Indici_FormMode.Search ? undefined : 1}
                    componentRef={peoplePickerRef}

                    // eslint-disable-next-line react/jsx-no-bind
                    onResolveSuggestions={onResolveSuggestions}
                    onInputChange={onPeoplePickerInputChange}
                    onValidateInput={contactsFieldBasePickerProps?.onValidateInput ?? validatePersonaInput}
                    onEmptyResolveSuggestions={contactsFieldBasePickerProps?.onEmptyResolveSuggestions}
                    onItemSelected={onContactSelected}
                    onChange={onContactChange}

                    onRenderSuggestionsItem={onRenderSuggestionsItem}
                    onRenderItem={onRenderItem}
                />
                {contactsField.touched && !contactsField.valid && <span className="error-message">Campo obbligatorio</span>}

            </div>
        </div>
    );


};


const ForwardedAutocompleteContact = React.forwardRef(AutocompleteContact);
export default ForwardedAutocompleteContact;






/**
 * Takes in the picker input and modifies it in whichever way
 * the caller wants, i.e. parsing entries copied from Outlook (sample
 * input: "Aaron Reid <aaron>").
 *
 * @param input The text entered into the picker.
 */
function onPeoplePickerInputChange(input: string): string {
    const outlookRegEx = /<.*>/g;
    const emailAddress = outlookRegEx.exec(input);

    if (emailAddress && emailAddress[0]) {
        return emailAddress[0].substring(1, emailAddress[0].length - 1);
    }

    return input;
}

function getTextFromPersonaItem(persona: any): string {
    return persona.contatto as string;
}


function validatePersonaInput(input: string): ValidationState {
    if (input.indexOf('@') !== -1) {
        return ValidationState.valid;
    } else if (input.length > 1) {
        return ValidationState.warning;
    } else {
        return ValidationState.invalid;
    }
}


